import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings<{ hint: string; copied: string }>({
  en: {
    copied: 'Copied',
    hint: 'Copy?',
  },
  fr: {
    copied: 'Copié',
    hint: 'Copier ?',
  },
} as const);

export default locales;
